module.exports = {
    ALL: [
        {
            name: 'Truemoney',
            key: 'truemoney',
            logo: 'truemoney.png',
            country: 'th',
            hasCard: true,
            hasSerial: false,
            showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'SMS',
            key: 'sms',
            logo: 'sms.jpg',
            country: 'th',
            hasCard: false,
            hasSerial: false,
            showAmountList: true,
            amount: {
              THB: [50, 100, 150, 200 ,250 ],
              IDR: [20000, 25000, 50000, 100000, 200000]
            }
        },
        {
            name: '12Call',
            key: '12call',
            logo: '12call.png',
            country: 'th',
            hasCard: true,
            hasSerial: false,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'happy',
            key: 'dtac',
            logo: 'happy.png',
            country: 'th',
            hasCard: true,
            hasSerial: false,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }

        },
        {
            name: 'Bluecoins',
            key: 'bluecoins',
            logo: 'bluecoins.png',
            country: 'th',
            hasCard: true,
            hasSerial: false,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'Viettel',
            key: 'viettel',
            logo: 'viettel.png',
            country: 'vn',
            hasCard: true,
            hasSerial: true,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'Vinaphone',
            key: 'vinaphone',
            logo: 'vinaphone.png',
            country: 'vn',
            hasCard: true,
            hasSerial: true,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'Mobifone',
            key: 'mobifone',
            logo: 'mobifone.png',
            country: 'vn',
            hasCard: true,
            hasSerial: true,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'VTC',
            key: 'vtc',
            logo: 'vtc.png',
            country: 'vn',
            hasCard: true,
            hasSerial: true,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'Hope',
            key: 'hope',
            logo: 'buy.png',
            country: 'vn',
            hasCard: true,
            hasSerial: true,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
        {
            name: 'Indomog',
            key: 'indomog',
            logo: 'indomog.png',
            country: 'id',
            hasCard: true,
            hasSerial: false,
          showAmountList: false,
          amount: {
            THB: [],
            IDR: []
          }
        },
    ]
};



// WEBPACK FOOTER //
// ./src/config/pay/bluepay.js